<template>
    <div class="userProtocol" @touchmove.prevent @mousewheel.prevent>
        <div class="proto_box">
            <div class="proto_text">
                <h2>活动协议</h2>
                <p>尊敬的用户您好：<br/>
                1.此次活动依赖您提供的个人信息才能得以实施。需要您在申请页面中提供您的姓名、地址、电话、身份证信息、孕检证明/宝宝出生证明等必要信息用以完成申请资质审核及后续产品的派送。除为完成本次活动必要以及国家法律相关规定外，上述信息会进行保密，不会向他方进行提供（针对您的申领渠道会同步您的信息给申领渠道对您进行服务）<br/>
                2.本次申领活动结束前每天9点限时开放，每天申领上限1万人。达到申请上限后，您将无法提交个人信息，同时系统也无法获取您的个人信息。<br/><br/>
                我已阅读《活动协议》，同意对个人信息进行收集和使用</p>
            </div>
            <div class="proto_btns">
                <span class="disagree" @click="disagree">不同意</span>
                <span class="agree" @click="agree">同意</span>
            </div>
        </div>
    </div>
</template>
<style lang="less" scoped>
.userProtocol{
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    position: fixed;
    top: 0;
    left: 0;
    .proto_box{
        position: fixed;
        top: 0;bottom: 0;
        left: 0;right: 0;
        margin: auto;
        width: 334px;
        height: 505px;
        .proto_text{
            width: 278px;
            height: 415px;
            background:rgba(255,255,255,1);
            border-radius:30px;
            padding: 25px 28px 0;
            h2{
                font-size:20px;
                font-weight:bold;
                color:rgba(5,67,152,1);
                line-height:30px;
                text-align: center;
            }
            p{
                margin-top: 15px;
                font-size:13px;
                font-weight:bold;
                color:rgba(51,51,51,1);
                line-height:23px;
            }
        }
        .proto_btns{
            width: 286px;
            height: 50px;
            margin-top: 15px;
            padding: 0 24px;
            overflow: hidden;
            span{
                width:120px;
                height:50px;
                text-align: center;
                line-height:50px;
                font-size:20px;
                font-weight:bold;
                border-radius:10px;
            }
            span.disagree{
                float: left;
                background:rgba(255,255,255,1);
                color:rgba(5,67,152,1);
            }
            span.agree{
                float: right;
                background:linear-gradient(-90deg,rgba(32,61,171,1),rgba(39,76,213,1));
                color:rgba(255,255,255,1);
            }
        }
    }
}
</style>
<script>
export default {
    name:"userProtocol",
    data() {
        return {
            
        }
    },
    mounted(){ 
    },
    methods:{
        // 不同意
        disagree(){
            this.$emit("disagreeProto");
        },
        // 同意
        agree(){
            this.$emit("agreeProto");
        }
    }
}
</script>